import sanitizeHtml from 'sanitize-html';

// Broadcast-only option set. The shared lib/helpers/htmlSanitizer has a dozen
// other callers and deliberately has no <img>; keep it that way.
export const EMAIL_SANITIZE_OPTIONS = {
  allowedTags: [
    'p',
    'br',
    'b',
    'strong',
    'i',
    'em',
    'u',
    'ul',
    'ol',
    'li',
    'a',
    'span',
    'img',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'rel'],
    span: ['style'],
    p: ['style'],
    img: ['src', 'alt', 'width', 'height', 'style'],
  },
  allowedSchemes: ['http', 'https', 'mailto'],
  allowedSchemesByTag: { img: ['https'] },
  allowedSchemesAppliedToAttributes: ['href', 'src'],
  allowProtocolRelative: false,
  // An <img> whose src was rejected above is just an empty box; drop it.
  exclusiveFilter: frame => frame.tag === 'img' && !frame.attribs.src,
};

export const sanitizeEmailHtml = html =>
  sanitizeHtml(html || '', EMAIL_SANITIZE_OPTIONS);

export const sanitizedEmailBody = value =>
  sanitizeEmailHtml(value).replace(/\n/g, '');

export const sanitizedSmsBody = value =>
  sanitizeHtml(value || '', { allowedTags: [] }).replace(/\n/g, '');
